import { Typography } from '@shinetools/lumen-react'
import { ReactElement } from 'react'

import { SuppliersTableRow } from '../../types/suppliersTableRow'
import { SuppliersTableNoDataField } from '../SuppliersTableNoDataField'

interface SuppliersTablePhoneCellProps {
  row: SuppliersTableRow
}

export const SuppliersTablePhoneCell = ({ row }: SuppliersTablePhoneCellProps): ReactElement => {
  if (row.phone === null || row.phone === '') {
    return <SuppliersTableNoDataField />
  }

  return <Typography.Text>{row.phone}</Typography.Text>
}
